import { combineReducers } from 'redux';

import mapObject from './reducer_map_object';
import mapActions from './reducer_map';
import media from './reducer_media';

// Main reducers contain edit, add, delete methods
// All have submethods to modify state through copying (JSON.parse)
// One single error reducer to handle any errors passed through

const rootReducer = combineReducers({
  mapActions,
  media,
  mapObject
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js